import React from 'react';
import cn from 'classnames';

import {IBadgeProps} from './IBadge';

const Badge = ({children, classNames}: IBadgeProps) => {
	return <div className={cn('badge', classNames)}>{children}</div>;
};

export default Badge;
